import { IShortCodeLink } from './short-code-link';

export interface IListShortCodeLinksResponse {
    data: {
        success: boolean;
        results: IShortCodeLink[];
    }
}
